/* Counts down to midnight in a named timezone and resets daily.

   Shared by the urgency widget and the exit-intent popup, because both are
   counting down the same offer and a second copy of the timezone handling would
   be a second thing to get wrong.

   Usage:
     <daily-countdown data-timezone="America/New_York"></daily-countdown> */
(function () {
  if (customElements.get('daily-countdown')) return;

  customElements.define(
    'daily-countdown',
    class DailyCountdown extends HTMLElement {
      connectedCallback() {
        this.timeZone = this.dataset.timezone || 'America/New_York';

        // An unknown zone name throws on first use; fall back rather than
        // leaving the element stuck on its placeholder.
        try {
          new Intl.DateTimeFormat('en-US', { timeZone: this.timeZone }).format();
        } catch (error) {
          this.timeZone = 'America/New_York';
        }

        this.tick();
        this.interval = setInterval(this.tick.bind(this), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      /* "Today" means the shop's day, not the visitor's: the offer is run from
         Alpharetta, so it ends at midnight Eastern for everyone. Read from the
         wall clock in that zone rather than by adding a fixed offset, so the
         switch to and from daylight saving is handled by the platform.

         Recomputed on every tick rather than counted down from a stored total,
         so the clock stays right if the tab sleeps or the device suspends.

         Known limit: on the two DST changeover days the local day is 23 or 25
         hours, so between midnight and the changeover this reads an hour out.
         Not worth correcting for a promo timer. */
      msUntilMidnight() {
        const now = new Date();
        const parts = new Intl.DateTimeFormat('en-US', {
          timeZone: this.timeZone,
          hour12: false,
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        }).formatToParts(now);

        const read = (type) => Number(parts.find((part) => part.type === type).value);
        // Some engines report midnight as hour 24 rather than 0.
        const hours = read('hour') % 24;
        const elapsed = (hours * 3600 + read('minute') * 60 + read('second')) * 1000 + now.getMilliseconds();
        return 86400000 - elapsed;
      }

      /* Units rather than a clock face: "10h 31m 58s" reads as a duration,
         where "10:31:58" reads as a time of day. Minutes and seconds are padded
         so the element does not change width on every tick. */
      format(ms) {
        const totalSeconds = Math.floor(ms / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        const pad = (n) => String(n).padStart(2, '0');

        if (hours > 0) return hours + 'h ' + pad(minutes) + 'm ' + pad(seconds) + 's';
        if (minutes > 0) return minutes + 'm ' + pad(seconds) + 's';
        return seconds + 's';
      }

      tick() {
        this.textContent = this.format(Math.max(0, this.msUntilMidnight()));
      }
    }
  );
})();
